<template>
  <div class="thankyou-page">
   
    <b-row>
      <b-col cols="12" lg="12">
        <div class="text-wrap">
        <p class="hr-title"><hr class="hr-purple"><b>Have Your Say</b></p>
        <h1>Thank You!</h1>
        <p>Your Feedback has been submitted, we appreciate your time.</p>
        <p>The purpose of this consultation is to get your views on the routes considered and on the selection of the emerging preferred route options. The Department will publish a summary of responses following completion of the consultation process. Your response, and all other responses to the consultation, may be disclosed on request. The Department can only refuse to disclose information in exceptional circumstances.</p>
        <p>All responses are confidential. Please refer to <a href="https://firebasestorage.googleapis.com/v0/b/pinpoint-belfastrapidtransit.appspot.com/o/Appendix_Belfast.pdf?alt=media&token=44f4ce4c-dde3-457f-bd87-053acd53263c" target="_blank">Appendix 1 text from brochure</a> which will give you guidance on the legal position about any information given by you in response to this consultation.</p>
        
        <h1>Dfl Contact Details</h1>
        <p>Mr Clive Robinson, BRT Programme Manager<br/>Department for Infrastructure,<br/>Transport Projects Branch,<br/>Clarence Court, 10-18 Adelaide Street,<br/> Belfast, BT2 8GB<br/></p>
        <p><b>Email:</b> <a href="mailto:BRT2@infrastructure-ni.gov.uk">BRT2@infrastructure-ni.gov.uk</a><br/><b>Freephone:</b> 0800 054 1160</p>
          <div class="bottom-fixed"><button v-on:click="gobackhome()"  class="" role="button"> Back to home</button></div>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>

export default {
  name: "ThankYou",
  props: {
    title: {
      type: String,
      default: "Slider Title",
    },
    text: {
      type: String,
      default: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    button: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "Button",
    },
    carousel: {
      type: Array,
      default() {
        return [{}];
      },
    },
    link: {
      type: String,
      default: "/",
    },
  },
  components: {
    
  },
  methods: {
    gobackhome: function () {
     top.window.location.href = '/site/homePage';
    }
  }
};
</script>

<style lang="scss">
.thankyou-page{
    margin:2rem;
}
</style>